import React from 'react'
import Enum from 'swift-enum'

import DashboardItem from '../etc/dashboard-item'
import frameworkStyles from '../components/FrameworkStyles'
import ProjectInfo from '../components/ProjectInfo'
import {withStyles} from 'material-ui/styles'
import withPaper from './with-paper'
import AppBar from 'material-ui/AppBar'
import Toolbar from 'material-ui/Toolbar'
import Grid from 'material-ui/Grid'
import Card, {CardHeader, CardContent} from 'material-ui/Card'
import {chartSizes, framework as appTheme} from '../etc/theme'
import Typography from 'material-ui/Typography'
import inFullScreen from '../hoc/full-screen'

let styles = theme => ({
  ...frameworkStyles(theme),
  itemPaper: theme.mixins.gutters({
    paddingTop: 0,
    paddingBottom: 16,
    overflowX: 'auto',
  }),
  tagline: appTheme.typography.tagline.style,
  card: {height: 320},
  chart: {margin: '0 auto'}
})

let _DatasetHome = ({dataset, match, history, base_url, classes}) => (
  <Grid
      container
      spacing={8}
      justify='center'
      className={classes.actualContent}
    > 
      {
        DashboardItem.cases.map(item => {
          let {MainChart, Filter, taglineSelector} = item.parts
          let title = item.title
          let noop = ()=>{}
          let onClick=()=>{
            history.push(`${base_url}/${item.route}`)
          }
            return (
              <Grid 
              item
              key={item.route}
              xs={12}
              sm={6}
              md={4}
              lg={3}
              >

              <Card key={item.route} className={classes.card} onClick={onClick}>
                  <CardHeader title={title} />
                  <CardContent>
                    <MainChart 
                      dataset={dataset} 
                      currentFilter={Filter.none} 
                      onSetFilter={noop} 
                      radius={chartSizes.radius.small}
                      width={chartSizes.width.small}
                      height={chartSizes.height.small}
                      className={classes.chart}
                    />
                    <Typography className={classes.tagline} type={appTheme.typography.tagline.type}>
                      {taglineSelector(dataset)}
                    </Typography>
                </CardContent>
            </Card>
            </Grid>
            )
        })
      }
    </Grid>
)



// let DatasetHome = ({dataset, match, history, base_url, classes}) => (
//   <div className={classes.root}>
//     <AppBar 
//       position='fixed' 
//       className={classes.appBar}
//       elevation={2}
//       color="primary"
//     >
//       <Toolbar disableGutters={true}>
//         <ProjectInfo 
//           classes={{root: classes.projectHeader}} 
//           project_info={dataset}
//         />
//       </Toolbar>
//     </AppBar>
//     <div className={classes.content}>
//       <Grid
//           container
//           spacing={8}
//           justify='center'
//           className={classes.actualContent}
//         > 
//           {
//             DashboardItem.cases.map(item => {
//               let {MainChart, Filter, taglineSelector} = item.parts
//               let title = item.title
//               let noop = ()=>{}
//               let onClick=()=>{
//                 history.push(`${base_url}/${item.route}`)
//               }
//                 return (
//                   <Grid 
//                   item
//                   key={item.route}
//                   xs={12}
//                   sm={6}
//                   md={4}
//                   lg={3}
//                   >
  
//                   <Card key={item.route} className={classes.card} onClick={onClick}>
//                       <CardHeader title={title} />
//                       <CardContent>
//                         <MainChart 
//                           dataset={dataset} 
//                           currentFilter={Filter.none} 
//                           onSetFilter={noop} 
//                           radius={chartSizes.radius.small}
//                           width={chartSizes.width.small}
//                           height={chartSizes.height.small}
//                           className={classes.chart}
//                         />
//                         <Typography className={classes.tagline} type={appTheme.typography.tagline.type}>
//                           {taglineSelector(dataset)}
//                         </Typography>
//                     </CardContent>
//                 </Card>
//                 </Grid>
//                 )
//             })
//           }
//         </Grid>
//     </div>
//   </div>
// )

export default inFullScreen(ProjectInfo)(withStyles(styles)(_DatasetHome))


/* 

                  <Grid item xs={12} sm={4} key={item.rawValue}>
                    <ItemComponent 
                      title={item.title} 
                      data={dataset} 
                      link={`${base_url}/${item.route}`}
                      home_link={match.url}
                      compact={true} 
                    />
                  </Grid>


                  */


// WEBPACK FOOTER //
// ./src/components/DatasetHome.js